// orchestrator_fullstack/frontend/src/app/auth/useCan.ts
import { useMemo } from "react";
import { useAuth } from "./AuthProvider";
import { can as canPerm, normalizeRoles, Permission } from "./rbac";

/**
 * useCan() returns a stable function you can call like:
 *   const can = useCan();
 *   if (can("admin.overview.view")) ...
 *
 * This matches how AdminLayout and <Can/> are typically written.
 */
export function useCan() {
  const { state } = useAuth();

  // Normalize once so we never deal with odd shapes
  const roles = useMemo(() => normalizeRoles(state.roles), [state.roles]);

  // Return a stable function
  return useMemo(() => {
    return (permission: Permission) => canPerm(roles, permission);
  }, [roles]);
}

export default useCan;